import type { FaireProductEntity } from "../../entity_types/product";

export const bamboo_whisk: FaireProductEntity = {
  token: "bamboo-whisk",
  type: "product",
  name: "Japanese Style Bamboo Tea Whisk",
  brandName: "Fodory",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/700a581cb33a5b4462bea91d0e3b42c62a8306d3b2242f876d8b455f24c9a53c.webp",
  priceDollars: 15,
  msrpDollars: 30,
  freeShipping: false,
  isBestseller: false,
  description: "",
  categoryTokens: ["cat_proto_home-and-living"],
  tags: [],
  inStock: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "legacy-products-migration",
  },
};
